export default __webpack_public_path__ + "static/media/adv-2.eb32039c.jpg";